export default __webpack_public_path__ + "static/media/REAZIONE_ICONA.60911222.svg";